import { useState } from 'react';

import { BenefitSetForm } from 'libs/forms';
import { setStayHandicaped } from 'services/stay-service';

export const FreeBlock = (props) => {
  const { id, refresh, close } = props;
  const [working, setWorking] = useState(false);

  // const { t } = useTranslation();

  const action = async ({ reason }) => {
    // console.log('reason', reason);
    setWorking(true);
    await setStayHandicaped({ stay_id: id, exemption_document: reason });
    refresh();
    setWorking(false);
    close();
  };

  return <BenefitSetForm close={close} working={working} action={action} />;
};
